import { LanguagePackTemplate } from "~/language_packs/index";
import { AUTH_LEVELS } from "~/typings/enums";

export const languagePackEn: LanguagePackTemplate = {
};
